/* eslint-disable react/prop-types */
import { Controller } from "react-hook-form";
import { Checkbox, FormControlLabel, FormHelperText, Box } from "@mui/material";

const RHFCheckbox = ({ formData, control, values }) => {
    // Generate validation rules dynamically
    const rules = formData?.Validations?.reduce((acc, validation) => {
        if (validation.ValidationType === "Required") {
            acc.required = validation.ValidationMessage || "This field is required";
        }
        return acc;
    }, {});

    return (
        <Controller
            name={formData?.ValueExpr}
            control={control}
            rules={rules}
            render={({ field, fieldState: { error } }) => (
                <Box>
                    <FormControlLabel
                        control={
                            <Checkbox
                                {...field}
                                checked={!!field.value}
                                onChange={(e) => field.onChange(e.target.checked)}
                                style={{ transform: 'scale(0.8)' }}
                                disabled={values.ParentschemeId && ['ExcludeException', 'GroupApplicable', 'IsStandard', 'IsParentScheme'].includes(formData?.ValueExpr)}
                            />
                        }
                        label={
                            <>  
                                
                                <span style={{ color: "black" }}>{formData?.LabelName || formData?.DisplayExpr}</span>
                                {rules?.required && (
                                    <span style={{ color: "red", marginLeft: "2px" }}>*</span>
                                )}
                            </>
                        }
                        sx={{
                            "& .MuiFormControlLabel-label": {
                                fontSize: "13px",
                            },
                        }}
                    />
                    {error && (
                        <FormHelperText error sx={{ fontSize: "10px", ml: 1.5 }}>
                            {error.message}
                        </FormHelperText>
                    )}
                </Box>
            )}
        />
    );
};

export default RHFCheckbox;
